import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { Alert, Box, Button, CircularProgress, Container, Dialog, DialogActions, DialogContent, FormControl, Grid, IconButton, InputLabel, LinearProgress, MenuItem, Paper, Select, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, 
  TableRow, Toolbar, Typography 
} from '@mui/material';

import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import UndoIcon from '@mui/icons-material/Undo';

import { NavbarInicio } from '../ui/NavbarInicio';

import { usePages } from '../../hooks/usePages';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { ActualizarTipoTramiteUsuario, AgregarTipoTramiteUsuario, ObtenerTiposTramiteUsuario } from '../../actions/catalogos/tipoTramiteUsuarioActions';
import { ObtenerTipoUsuarios } from '../../actions/catalogos/tipoUsuarioActions';
import { ObtenerTipoTramites } from '../../actions/catalogos/tipoTramiteActions';

import { usePermisos } from '../../hooks/usePermisos';

import { NotFoundScreen } from '../auth/NotFoundScreen';
    
export const TipoTramiteUsuarioScreen = ( ) => {

    const { tipoUsuario : tipoUsuarioRedux, loading } = usePermisos();

    const navigate = useNavigate();

    const [errors, setErrors] = useState({ });

    const [rows, setRows] = useState( [ ] );

    const [tipoTramite, setTipoTramite] = useState( 0 );
    const [tipoTramiteArray, setTipoTramiteArray] = useState( [ ] );

    const [tipoUsuario, setTipoUsuario] = useState( 0 );
    const [tipoUsuarioArray, setTipoUsuarioArray] = useState( [ ] );

    const [idReferencia, setIdReferencia] = useState( '' );
    const [opcion, setOpcion] = useState( '' );

    const [loadingTable, setLoadingTable] = useState( true );
    const [loadingSave, setLoadingSave] = useState( false );
    const [openModal, setOpenModal] = useState( false );
  
    const [page, rowsPerPage, handleChangePage, handleChangeRowsPerPage] = usePages();
  
    const handleChangeSwitch = ( id, value ) => {

        const newRows = rows.map( (row) => { if(row.idTipoTramiteUsuario === id){ row.activo = value; return row; } else{ return row; } } );
        setRows( newRows );        

        const tipoTramiteUsuario = rows.filter( function(row){ return row.idTipoTramiteUsuario === id; } );
        cambiarEstatus( tipoTramiteUsuario[0] );
    }

    const handleOpenModal = () => {
        setOpenModal(true);
    }

    const handleCloseModal = () => {

        setTipoTramite( 0 );
        setTipoUsuario( 0 );

        setOpenModal(false);
        setErrors( { } );
    }

    const cambiarEstatus = async ( { idTipoTramiteUsuario, idTipoTramite, idTipoUsuario, activo } ) => {

        const params = {
            idTipoTramiteUsuario,
            idTipoTramite,
            idTipoUsuario,
            activo,
        };

        await ActualizarTipoTramiteUsuario( params );
    }

    const AgregarRegistro = () => {

        setTipoTramite( 0 );
        setTipoUsuario( 0 );

        setOpcion( 'agregar' );
        setIdReferencia( 0 );

        handleOpenModal();
    }

    const EditarRegistro = ( id, idTipoTramite, idTipoUsuario ) => {
        
        setTipoTramite( idTipoTramite );
        setTipoUsuario( idTipoUsuario );

        setOpcion( 'editar' );
        setIdReferencia( id );

        handleOpenModal();
    }

    const Guardar = async () => {

        const valid = validateFiels();

        if( !valid ){
            return false;
        }

        setLoadingSave( true );

        const validate = validateDuplicidad();
        if( !validate ) return;

        if( opcion === 'agregar' ){

            const params = {
                idTipoTramiteUsuario: 0,
                idTipoTramite: tipoTramite,
                idTipoUsuario: tipoUsuario,
                activo: true,
            };

            await AgregarTipoTramiteUsuario( params ).then( response => {
                if( response ){
                    if( response.status === 200){
                        if( response.data ){
                            
                            setTimeout(() => {
                                
                                setRows([ 
                                    ...rows,  
                                    {
                                        idTipoTramiteUsuario: response.data.idTipoTramiteUsuario,
                                        idTipoTramite: response.data.idTipoTramite,
                                        tipoTramite: response.data.tipoTramite,
                                        idTipoUsuario: response.data.idTipoUsuario,
                                        tipoUsuario: response.data.tipoUsuario,
                                        activo: true
                                    }
                                ]);  
    
                                handleCloseModal();

                                setLoadingSave( false );

                            }, 1000);                            
                            
                        } 
                    }
                }
            });
        }

        if( opcion === 'editar' ){

            const tipoTramiteUsuario = rows.filter( function(row){ return row.idTipoTramiteUsuario === idReferencia; } )[0];

            const params = {
                IdTipoTramiteUsuario: idReferencia,
                idTipoTramite: tipoTramite,
                idTipoUsuario: tipoUsuario,
                activo: tipoTramiteUsuario.activo,
            };
    
            await ActualizarTipoTramiteUsuario( params ).then( response => {
                if( response ){
                    if( response.status === 200){

                        setTimeout(() => {
                                
                            const newRows = rows.map( (row) => { 
                                if(row.idTipoTramiteUsuario === idReferencia){ 
                                    row.idTipoTramite = response.data.idTipoTramite;
                                    row.tipoTramite = response.data.tipoTramite;
                                    row.idTipoUsuario = response.data.idTipoUsuario;
                                    row.tipoUsuario = response.data.tipoUsuario;
                                    return row; 
                                } 
                                else{ 
                                    return row; 
                                } 
                            });
    
                            setRows( newRows ); 
                            
                            handleCloseModal();

                            setLoadingSave( false );

                        }, 1000);                        
                        
                    }
                }                
            });
        }
    }

    const validateDuplicidad = () => {

        const even = (e) => e.idTipoTramite === tipoTramite && e.idTipoUsuario === tipoUsuario;
        const validateAdd = rows.some( even );

        if( validateAdd ){

            const tipoTramitesItems = tipoTramiteArray.find( (e) => e.idTipoTramite === tipoTramite );
            const tipoUsuariosItems = tipoUsuarioArray.find( (e) => e.idTipoUsuario === tipoUsuario );

            setErrors({ add: 'El Tipo de Trámite ' + tipoTramitesItems?.descripcion + ' y el Tipo de Usuario ' + tipoUsuariosItems?.descripcion + ' ya estan agregados' });
            
            setLoadingSave( false );

            return false;
        }

        return true;
    }

    const validateFiels = () => {
        
        setErrors( { } );

        let valid = true;
        let errores = {};
        
        if( tipoTramite === 0 ){
            valid = false;
            errores.tipoTramite = 'Debes seleccionar un tipo de trámite';
        }  

        if( tipoUsuario === 0 ){
            valid = false;
            errores.tipoUsuario = 'Debes seleccionar un tipo de usuario';
        }  
        
        setErrors( errores );
        return valid;
    } 

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerTiposTramiteUsuario().then(response => {
                
                if( response ){
                    if( response.status === 200 ){
                       
                        setTimeout(() => {
                        
                            setLoadingTable( false );
                            setRows( response.data );

                        }, 1000);

                    }
                }
                
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerTipoUsuarios().then(response => {
                
                if( response ){
                    if( response.status === 200 ){
                        setTipoUsuarioArray( response.data );
                    }
                }
                
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerTipoTramites().then(response => {
                
                if( response ){
                    if( response.status === 200 ){
                        setTipoTramiteArray( response.data );
                    }
                }
                
            });

        }

        Obtener();

    }, [ ]);

    return (
        <>
            
            <NavbarInicio />

            {
                ( !loading && tipoUsuarioRedux !== 3 )
                &&
                <NotFoundScreen />
            }

            {
                ( !loading && tipoUsuarioRedux === 3  )
                &&   
                <>

                    <Container maxWidth='xl' sx={{ mt: { md: '13em', xs: '11em' } }}>

                        <Box sx={{ pb: '2em', pl: { md: 10, xs: 1 }, pr: { md: 10, xs: 1 }, pt: 2 }} component={ Paper } >	

                            <Container maxWidth="lg">   

                                <Grid container spacing={3} sx={{ mt: 1 }} >  
                                        
                                    <Grid item md={6} xs={6} sx={{ textAlign: 'left' }}> 
                                        <Button type="button" startIcon={ <UndoIcon /> } variant='contained' color='inherit' sx={{ mt: 1 }} onClick={ () => navigate('/administracion/') }> 
                                            Regresar a los catálogos
                                        </Button> 
                                    </Grid>

                                    <Grid item md={6} xs={6} sx={{ textAlign: 'right' }}> 
                                        <Button type="button" startIcon={ <AddCircleOutlineRoundedIcon /> } variant="contained" sx={{ mt: 1 }} onClick={ AgregarRegistro }> 
                                            Agregar
                                        </Button> 
                                    </Grid>

                                </Grid>

                                <Grid container spacing={3} sx={{ mt: 1 }} >  
                                    
                                    <Grid item xs={12} md={12}> 

                                        <Toolbar sx={{ pl: { sm: 2 }, pr: { xs: 1, sm: 1 } }} >
                                            <Typography sx={{ flex: '1 1 100%' }} variant="h6" component="div" >
                                                Tipo trámite - Usuario
                                            </Typography>
                                        </Toolbar>

                                        <TableContainer>

                                            <Table sx={{ minWidth: 500 }} >
                                                <TableHead>
                                                    <TableRow>        
                                                        <TableCell style={{ width:'10%' }}> ID </TableCell>
                                                        <TableCell style={{ width:'10%' }}> TIPO TRÁMITE </TableCell>
                                                        <TableCell style={{ width:'30%' }}> TIPO USUARIO </TableCell>
                                                        <TableCell style={{ width:'10%' }}> HABILITADO </TableCell>
                                                        <TableCell style={{ width:'10%' }}> EDITAR </TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                {
                                                (rowsPerPage > 0
                                                    ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    : rows
                                                ).map((row) => (
                                                    <TableRow key={ row.idTipoTramiteUsuario} >
                                                    
                                                        <TableCell style={{ fontWeight: 'bold' }}>
                                                            { row.idTipoTramiteUsuario }
                                                        </TableCell>

                                                        <TableCell>
                                                            { row.tipoTramite.descripcion }
                                                        </TableCell>

                                                        <TableCell>
                                                            { row.tipoUsuario.descripcion }
                                                        </TableCell>
                                                        
                                                        <TableCell>
                                                            {
                                                                row.activo 
                                                                ? 
                                                                (
                                                                    <Switch 
                                                                        inputProps={ { 'aria-label': 'Switch demo'} } 
                                                                        checked={ row.activo } 
                                                                        onChange={ ( e ) => handleChangeSwitch( row.idTipoTramiteUsuario, e.target.checked ) }
                                                                    />
                                                                ) 
                                                                :                                           
                                                                ( 
                                                                    <Switch 
                                                                        inputProps={ { 'aria-label': 'Switch demo'} } 
                                                                        checked={ row.activo } 
                                                                        onChange={ ( e ) => handleChangeSwitch( row.idTipoTramiteUsuario, e.target.checked ) }
                                                                    />
                                                                )
                                                            }
                                                        </TableCell>

                                                        <TableCell>
                                                            <IconButton 
                                                                    color="primary" 
                                                                    aria-label="edit" 
                                                                    component="span" 
                                                                    onClick={ () => EditarRegistro( row.idTipoTramiteUsuario, row.tipoTramite.idTipoTramite, row.tipoUsuario.idTipoUsuario ) }
                                                                >                                                        
                                                                <EditIcon />
                                                            </IconButton>  
                                                        </TableCell>

                                                    </TableRow>
                                                ))}

                                                { 
                                                    rows.length === 0 && (
                                                        <TableRow style={{ height: 53 }}>

                                                            <TableCell colSpan={10} align="center"> 
                                                                {
                                                                    loadingTable
                                                                    ?
                                                                        <CircularProgress size={40} sx={{ mt: 2, mb: 2 }} />
                                                                    :
                                                                        ''
                                                                }
                                                                {
                                                                    !loadingTable && rows.length === 0
                                                                    ?
                                                                        'No se encontraron usuarios'
                                                                    :
                                                                        ''
                                                                }
                                                            </TableCell>

                                                        </TableRow>
                                                    )
                                                }

                                                </TableBody>

                                                <TableFooter>
                                                    <TableRow>
                                                        <TablePagination
                                                            rowsPerPageOptions={[ 5, 10, 15, 20, 25, 50, 100 ]}
                                                            colSpan={6}
                                                            count={rows.length}                                        
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}                                                                                
                                                            onPageChange={ handleChangePage }
                                                            onRowsPerPageChange={ handleChangeRowsPerPage }
                                                            ActionsComponent={ TablePaginationActions }

                                                            labelRowsPerPage="Filas por página"                                            
                                                            labelDisplayedRows={
                                                                ({ from, to, count }) => {
                                                                return '' + from + '-' + to + ' de ' + count
                                                                }
                                                            }  
                                                        />
                                                    </TableRow>
                                                </TableFooter>
                                            </Table>
                                        </TableContainer>
                                
                                </Grid>

                            </Grid>

                        </Container>

                    </Box>             

                    </Container>

                    <Dialog open={ openModal } maxWidth='sm' fullWidth={true}>       
                    
                        <DialogContent>
                            
                            <FormControl fullWidth sx={{ mt: 3 }} >
                                <InputLabel id="select-tipoTramite-label">Tipo de Trámite</InputLabel>
                            
                                <Select
                                    labelId="select-tipoTramite-label"
                                    id="select-tipoTramite"                                            
                                    label="Tipo de Trámite"
                                    name="tipoTramite"
                                    value={ tipoTramite }                                
                                    onChange={ ( e ) => { setTipoTramite( e.target.value ) } }
                                >
                                    <MenuItem key={0} value={0}>Seleccione una opción</MenuItem>
                                    {
                                        tipoTramiteArray.map( ( elem ) => (
                                            <MenuItem key={ elem.idTipoTramite } value={ elem.idTipoTramite }> { elem.descripcion } </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                            {   
                                errors.tipoTramite && ( <Alert color='warning' severity="warning" variant="filled" style={{ marginTop: '1em' }} > { errors.tipoTramite } </Alert> )
                            }

                            <FormControl fullWidth sx={{ mt: 3 }} >
                                <InputLabel id="select-tipoUsuario-label">Tipo de Usuario</InputLabel>
                            
                                <Select
                                    labelId="select-tipoUsuario-label"
                                    id="select-tipoUsuario"                                            
                                    label="Tipo de Usuario"
                                    name="tipoUsuario"
                                    value={ tipoUsuario }                                
                                    onChange={ ( e ) => { setTipoUsuario( e.target.value ) } }
                                >
                                    <MenuItem key={0} value={0}>Seleccione una opción</MenuItem>
                                    {
                                        tipoUsuarioArray.map( ( elem ) => (
                                            <MenuItem key={ elem.idTipoUsuario } value={ elem.idTipoUsuario }> { elem.descripcion } </MenuItem>
                                        ))
                                    }
                                </Select>

                            </FormControl>

                            {   
                                errors.tipoUsuario && ( <Alert color='warning' severity="warning" variant="filled" style={{ marginTop: '1em' }} > { errors.tipoUsuario } </Alert> )
                            }
                            
                            {   
                                errors.add  && ( <Alert color='warning' severity="warning" variant="filled" style={{ marginTop: '1em' }} > { errors.add } </Alert> )
                            }

                        </DialogContent>

                        <DialogActions>
                            <Button onClick={ handleCloseModal }> Cancelar </Button>
                            <Button onClick={ Guardar } variant='contained' startIcon={ <SaveIcon /> } > Guardar </Button>
                        </DialogActions>

                        <LinearProgress sx={{ display: loadingSave ? 'flex' : 'none' }} />

                    </Dialog>

                </>
            }

        </>
    )
}
